import React, { useState, useEffect } from "react";
import { ListElement } from "./box-lista-style.js";
import "./score-style.css";
import "../../global-styles.css";
import api from "../../services/api.js";

import Modal from "../modal/modal.js";
import { TextoClicavel } from "../modalAdicionar/adicionar-style.js";
import Busca from "../busca/busca";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import ReactLoading from "react-loading";
import { toast } from "react-toastify";
import { toastProps } from "../../utils/toastProps.js";
import { TextAreaModal, TextDivModal } from "../TextField/styles.js";
import cancelar from "../../assets/cancelar.svg";
import confirm from "../../assets/confirm.svg";
import eye from "../../assets/eye.svg";
import { IconImage, TextTable } from "./styles.js";
import { useCallback } from "react";
import { ContainerHeaderTable } from "../HeaderTable/styles.js";

function BoxRequisicao({ getRecomendations, ...props }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [adicionarCategoriaIsOpen, setAdicionarCategoriaIsOpen] =
    useState(false);
  const [messageIsOpen, setMessageIsOpen] = useState(false);
  const [adicionarSugestaoIsOpen, setAdicionarSugestaoIsOpen] = useState(false);
  const [rejeitarIsOpen, setRejeitarIsOpen] = useState(false);
  const [motivoRecusa, setMotivoRecusa] = useState("");
  const [editStatusIsOpen, setEditStatusIsOpen] = useState(false);

  const [statusEdit, setStatusEdit] = useState(props.status || null);
  const [observacaoEdit, setObservacaoEdit] = useState(props.observacao || '');

  const [nome, setNome] = useState(props.nome);

  const [opcoesCategoria, setOpcoesCategoria] = useState([]);

  const [categoria, setCategoria] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);

  const [categoriasFinais, setCategoriasFinais] = useState([]);
  const [novaCategoria, setNovaCategoria] = useState(props.categoria);
  const [marca, setMarca] = useState(props.marca);
  const [volume, setVolume] = useState(props.volume);
  const [upc, setUpc] = useState(props.upc);
  const [imagemFinal, setImagemFinal] = useState(props.imagem1);
  const [ingredientes, setIngredientes] = useState([]);
  const [mensagemErro, setMensagemErro] = useState(" ");
  const [loading, setLoading] = useState(false);
  const [whichImage, setWhichImage] = useState();
  const [imageOptions, setImageOptions] = useState();
  const [loadingUpload, setLoadingUpload] = useState(false);


  const url = "/api/sugestoes/" + props.id + "/";

  useEffect(() => {
    let newOptions = [{ nome: "Nova imagem" }];

    if (props.imagem1) {
      newOptions = newOptions.concat([{ nome: "Imagem 1" }]);
    }

    if (props.imagem2) {
      newOptions = newOptions.concat([{ nome: "Imagem 2" }]);
    }

    setImageOptions(newOptions);
  }, [adicionarSugestaoIsOpen, props.imagem1, props.imagem2]);

  const adicionarProduto = async (e) => {
    e.preventDefault();
    if (nome === "") {
      setMensagemErro("Insira um nome");
      return;
    }

    if (categoriasFinais.length === 0) {
      setMensagemErro("Insira uma categoria");
      return;
    }

    if (marca === "") {
      setMensagemErro("Insira uma marca");
      return;
    }

    setLoading(true);

    let ingredientesId = [];
    ingredientesId = ingredientes.map((ingrediente) => {
      return ingrediente.id;
    });

    let imageUrl =
      whichImage === "Imagem 1"
        ? props.imagem1
        : whichImage === "Imagem 2"
          ? props.imagem2
          : "";
    console.log("imagem", imageUrl);
    const body = {
      nome: nome,
      categorias: categoriasFinais,
      marca: marca,
      volume: volume,
      upc: upc,
      image_url: `https://rotulos-s3.s3.sa-east-1.amazonaws.com/appcosmeticos/${imageUrl}`,
      ingredientes: ingredientesId,
    };
    console.log(",hello", body);
    try {
      const response = await api.get("/auth/users/me/");
      const bodyHistory = {
        user: response.data.id,
        model_name: nome,
        model_type: "Produto",
        operation: "+",
      };
      const response1 = await api.post("/api/editionhistory/", bodyHistory);

      console.log(response1);
      console.log("url,", url, body);
      await api.patch(url, body);
      await api.post(`${url}validar/`, body);

      setAdicionarSugestaoIsOpen(false);
      setMessageIsOpen(true);

      if (getRecomendations) getRecomendations();
      toast.success("Produto adicionado com sucesso!", toastProps);

    } catch (error) {
      setMensagemErro(error.response.data.error);
      console.log(error.response.data);
    }
    setLoading(false);
  };

  const onFileUpload = async () => {
    if (!imagemFinal.type) {
      return;
    }

    const typeNovo = imagemFinal.type.substring([6]);
    setLoadingUpload(true);
    await api
      .get("/api/file/upload/" + typeNovo + "/")
      .then(async (res) => {
        // let foo = imagemFinal.slice(0, imagemFinal.size, imagemFinal.type);
        // let bar = new File([foo], res.data.file_name, {
        //   type: imagemFinal.type,
        // });
        const formData = new FormData();
        formData.append("file_name", res.data.file_name);
        formData.append("file", imagemFinal);
        console.log("res.data.file_name", res.data.file_name);
        console.log("imagem", imagemFinal);

        await api
          .post("/api/file/upload/" + typeNovo + "/", formData)
          .then((res) => {
            console.log(res);
            toast.success("Imagem adicionada com sucesso", toastProps);
          })
          .catch((err) => {
            console.log(err);
            toast.error("Erro ao adicionar imagem", toastProps);
          });
      })
      .catch((err) => console.error(err));
    setLoadingUpload(false);
  };

  const getCategoria = useCallback(async () => {
    api
      .get("/api/categorias/all/")
      .then((response) => (response = setOpcoesCategoria(response.data)));
  }, []);

  useEffect(() => {
    if (adicionarSugestaoIsOpen === true) {
      getCategoria();
    }
  }, [adicionarSugestaoIsOpen, getCategoria]);

  useEffect(() => {
    let categoriasId = [];
    if (categoria && categoria.length !== 0) {
      categoriasId[0] = categoria.id;
      subcategorias.forEach((subcategoria) => {
        categoriasId.push(subcategoria.id);
      });
      setCategoriasFinais(categoriasId);
    }
  }, [categoria, subcategorias]);

  const adicionarCategoria = async () => {
    const body = {
      nome: novaCategoria,
    };
    try {
      const response = await api.get("/auth/users/me/");
      const bodyHistory = {
        user: response.data.id,
        model_name: nome,
        model_type: "Categorias",
        operation: "+",
      };
      await api.post("/api/editionhistory/", bodyHistory);
      api.post("/api/categorias/", body).then(getCategoria());
    } catch (error) {
      toast.error("Erro ao adicionar categoria", toastProps);
    }
  };

  const eventhandlerIngrediente = (data) => {
    let ingredientesId = [];
    for (let item of data) {
      ingredientesId.push(item.id);
    }
    ingredientesId = data;
    setIngredientes(ingredientesId);
  };

  const rejeitar = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await api.get("/auth/users/me/");
      const bodyHistory = {
        user: response.data.id,
        model_name: nome,
        model_type: "Sugestao",
        operation: "-",
      };
      await api.post("/api/editionhistory/", bodyHistory);
      const motivoParam = motivoRecusa ? `?motivo=${encodeURIComponent(motivoRecusa)}` : '';
      await api.delete(`${url}recusar/${motivoParam}`);
      toast.success("Sugestão rejeitada com sucesso", toastProps);
      setMotivoRecusa("");
    } catch (error) {
      toast.error("Erro ao rejeitar sugestão", toastProps);
      console.log(error);
    }
    setLoading(false);
    setRejeitarIsOpen(false);
    setModalIsOpen(false);
    if (getRecomendations) getRecomendations();
  };

  const iniciarCadastro = async () => {
    try {
      await api.post(`${url}iniciar-cadastro/`);
      toast.success("Cadastro iniciado! Requisição travada para você.", toastProps);
      if (getRecomendations) getRecomendations();
    } catch (error) {
      toast.error(error.response?.data?.error || "Erro ao iniciar cadastro", toastProps);
    }
  };

  const liberarCadastro = async () => {
    try {
      await api.post(`${url}liberar-cadastro/`);
      toast.success("Requisição liberada.", toastProps);
      if (getRecomendations) getRecomendations();
    } catch (error) {
      toast.error(error.response?.data?.error || "Erro ao liberar cadastro", toastProps);
    }
  };

  const atualizarStatusRequisicao = async () => {
    setLoading(true);
    try {
      const urlStatus = `/api/sugestoes/${props.id}/atualizar_status/`;
      const body = {
        status: statusEdit,
        observacao: observacaoEdit
      };

      await api.patch(urlStatus, body);
      toast.success("Status atualizado com sucesso!", toastProps);
      setEditStatusIsOpen(false);

      if (getRecomendations) getRecomendations();

    } catch (error) {
      console.error(error);
      toast.error("Erro ao atualizar status", toastProps);
    }
    setLoading(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pendente': return '#FFC107'; // Amber
      case 'em_cadastro': return '#9C27B0'; // Purple
      case 'aguardando_info': return '#FF9800'; // Orange
      case 'erro': return '#F44336'; // Red
      case 'duplicada': return '#9E9E9E'; // Grey
      default: return '#879F85';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'pendente': return 'Pendente';
      case 'em_cadastro': return 'Em Cadastro';
      case 'aguardando_info': return 'Aguardando Info';
      case 'erro': return 'Com Erro';
      case 'duplicada': return 'Duplicada';
      default: return status || 'Sem Status';
    }
  };

  return (
    <ListElement>
      <ContainerHeaderTable
        width="32"
        justify="start"
        marginLeft={30}
        marginRight={10}
      >
        <TextTable>{props.nome}</TextTable>
      </ContainerHeaderTable>
      <ContainerHeaderTable
        width="29"
        justify="center"
        marginLeft={0}
        marginRight={10}
        style={{ flexDirection: 'column', alignItems: 'center' }}
      >
        <TextTable id="meio">{props.marca}</TextTable>

        {/* Badge de Status Clicável */}
        <div
          onClick={() => {
            setStatusEdit(props.status);
            setObservacaoEdit(props.observacao || '');
            setEditStatusIsOpen(true);
          }}
          title="Clique para alterar status"
          style={{
            marginTop: '5px',
            padding: '2px 8px',
            borderRadius: '10px',
            backgroundColor: getStatusColor(props.status),
            color: 'white',
            fontSize: '10px',
            fontWeight: 'bold',
            textAlign: 'center',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
          <span style={{ whiteSpace: 'nowrap' }}>
            {getStatusLabel(props.status)}
          </span>
        </div>

        {/* Data */}
        {props.dataCriacao && (
          <span style={{ fontSize: '10px', color: '#666', marginTop: '2px' }}>
            {new Date(props.dataCriacao).toLocaleDateString()}
          </span>
        )}

        {/* Lock Info */}
        {props.membroResponsavel && (
          <div style={{ fontSize: '10px', color: '#E91E63', fontWeight: 'bold', marginTop: '2px', textAlign: 'center' }}>
            <span role="img" aria-label="lock">🔒</span> {props.membroResponsavel.first_name}
          </div>
        )}
      </ContainerHeaderTable>

      <ContainerHeaderTable
        // width="15"
        minWidth="130"
        justify="space-evenly"
        marginLeft={0}
        marginRight={30}
      >
        {/* Botão de Lock/Unlock */}
        {!props.membroResponsavel ? (
          <div
            onClick={iniciarCadastro}
            title="Iniciar Cadastro (Lock)"
            style={{ cursor: 'pointer', marginRight: '5px', fontSize: '18px' }}
          >
            <span role="img" aria-label="unlocked">🔓</span>
          </div>
        ) : (
          <div
            onClick={liberarCadastro}
            title="Liberar Cadastro"
            style={{ cursor: 'pointer', marginRight: '5px', fontSize: '18px' }}
          >
            <span role="img" aria-label="locked">🔐</span>
          </div>
        )}
        <IconImage
          onClick={() => {
            setModalIsOpen(true);
          }}
          src={eye}
          width={23}
          height={23}
        />
        <IconImage
          onClick={() => {
            setAdicionarSugestaoIsOpen(true);
          }}
          src={confirm}
          width={20}
          height={20}
        />
        <IconImage
          onClick={() => {
            setRejeitarIsOpen(true);
          }}
          src={cancelar}
          width={20}
          height={20}
        />
      </ContainerHeaderTable>

      {modalIsOpen ? (
        <Modal
          container="containerAdicionar"
          onClose={() => setModalIsOpen(false)}
        >
          <h2 style={{ fontWeight: "bold" }}>{props.nome}</h2>
          <div className="inline" style={{ marginLeft: "7px" }}>
            {props.imagem1 && (
              <img
                src={props.imagem1}
                alt={props.nome}
                style={{ width: "300px", height: "300px" }}
              />
            )}
            {props.imagem2 && (
              <img
                src={props.imagem2}
                alt={props.nome}
                style={{ width: "300px", height: "300px" }}
              />
            )}
            {props.ingredientes && (
              <img
                src={props.ingredientes}
                alt={props.nome}
                style={{ width: "300px", height: "300px" }}
              />
            )}
          </div>
          {props.marca && (
            <>
              <p style={{ marginBottom: "1px", fontWeight: "bold" }}>Marca:</p>
              <p style={{ marginBottom: "2px" }}>{props.marca}</p>
            </>
          )}
          {props.descricao && (
            <>
              <p style={{ marginBottom: "1px", fontWeight: "bold" }}>
                descricao:
              </p>
              <p style={{ marginBottom: "2px" }}>{props.descricao}</p>
            </>
          )}
          {props.upc && (
            <>
              <p style={{ marginBottom: "1px", fontWeight: "bold" }}>
                Código de barras:
              </p>
              <p style={{ marginBottom: "2px" }}>{props.upc}</p>
            </>
          )}
          {props.name && (
            <>
              <p style={{ marginBottom: "1px", fontWeight: "bold" }}>
                Nome do Usuário:
              </p>
              <p style={{ marginBottom: "2px" }}>{props.name}</p>
            </>
          )}
          {props.email && (
            <>
              <p style={{ marginBottom: "1px", fontWeight: "bold" }}>
                Email do Usuário:
              </p>
              <p style={{ marginBottom: "2px" }}>{props.email}</p>
            </>
          )}
        </Modal>
      ) : null}
      {adicionarSugestaoIsOpen ? (
        <Modal
          container="containerAdicionar"
          onClose={() => setAdicionarSugestaoIsOpen(false)}
        >
          <form>
            <label htmlFor="nome">
              Nome<strong style={{ color: "red" }}>*</strong>
            </label>
            <TextDivModal height="40">
              <TextAreaModal
                style={{ width: 300 }}
                type="text"
                id="nome"
                value={nome}
                onChange={(event) => setNome(event.target.value)}
              />
            </TextDivModal>
            <label htmlFor="categorias">
              Categoria<strong style={{ color: "red" }}>*</strong>
            </label>
            <TextDivModal>
              <Autocomplete
                style={{ width: 300 }}
                options={opcoesCategoria}
                loadingText={"Carregando Categorias..."}
                autoHighlight
                getOptionLabel={(option) => option?.nome}
                onChange={(selected, values) => setCategoria(values)}
                renderOption={(option) => <>{option?.nome}</>}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={null}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password", // disable autocomplete and autofill
                    }}
                  />
                )}
              />
            </TextDivModal>
            <label htmlFor="categorias">Subcategorias</label>
            <TextDivModal>
              <Autocomplete
                style={{ width: 300 }}
                options={opcoesCategoria}
                loadingText={"Carregando Subcategorias..."}
                onChange={(selected, values) => setSubcategorias(values)}
                autoHighlight
                multiple
                getOptionLabel={(option) => option?.nome}
                renderOption={(option) => <>{option?.nome}</>}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={null}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password", // disable autocomplete and autofill
                    }}
                  />
                )}
              />
            </TextDivModal>
            <TextoClicavel>
              <button
                type="button"
                onClick={() => setAdicionarCategoriaIsOpen(true)}
              >
                Nova Categoria
              </button>
            </TextoClicavel>
            <label htmlFor="ingredientes">Ingredientes</label>
            <TextDivModal>
              <Busca
                url="/api/ingredientes-sw/"
                listOld={ingredientes}
                addAction
                onChange={eventhandlerIngrediente}
              />
            </TextDivModal>
            <label htmlFor="marca">
              Marca<strong style={{ color: "red" }}>*</strong>
            </label>
            <TextDivModal>
              <Busca
                url="/api/marcas/"
                onChange={(data) => {
                  if (data && data.length > 0) {
                    setMarca(data[0].nome);
                  } else {
                    setMarca("");
                  }
                }}
                addAction
                single
                listOld={marca ? [{ nome: marca }] : []}
                addSuccessMessage="Nova marca adicionada com sucesso"
                addErrorMessage="Erro ao adicionar marca"
              />
            </TextDivModal>
            <label htmlFor="volume">Volume</label>
            <TextDivModal height="40">
              <TextAreaModal
                style={{ width: 300 }}
                type="text"
                id="volume"
                value={volume || ""}
                onChange={(event) => setVolume(event.target.value)}
              />
            </TextDivModal>
            <label htmlFor="upc">Código de Barras</label>
            <TextDivModal height="40">
              <TextField
                style={{ width: 300 }}
                type="text"
                id="upc"
                value={upc || ""}
                onChange={(event) => setUpc(event.target.value)}
              />
            </TextDivModal>
            <label id="imagem">Imagem</label>
            <TextDivModal>
              <Autocomplete
                style={{ width: 300 }}
                options={imageOptions}
                autoHighlight
                getOptionLabel={(option) => option?.nome}
                onChange={(value, selected) => setWhichImage(selected?.nome)}
                renderOption={(option) => <>{option?.nome}</>}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={null}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password", // disable autocomplete and autofill
                    }}
                  />
                )}
              />
            </TextDivModal>
            {whichImage === "Nova imagem" ? (
              <>
                <input
                  style={{ width: 300, marginTop: 15, height: "max-content" }}
                  id="imagem"
                  type="file"
                  onChange={(event) => setImagemFinal(event.target.files[0])}
                  accept="image/*"
                />
                {loadingUpload && (
                  <ReactLoading
                    type="spokes"
                    color="#E6AC86"
                    height={20}
                    width={20}
                  />
                )}
                <TextoClicavel>
                  <button
                    type="button"
                    onClick={() => onFileUpload()}
                    disabled={!imagemFinal}
                  >
                    Confimar Imagem
                  </button>
                </TextoClicavel>
              </>
            ) : null}
            <button
              style={{ width: 300, marginBottom: "10px", cursor: "pointer" }}
              type="submit"
              onClick={(e) => adicionarProduto(e)}
              className="enviar"
            >
              {loading ? (
                <ReactLoading type="spin" color="#fff" height={20} width={20} />
              ) : (
                "Alterar"
              )}
            </button>
          </form>
          <p style={{ color: "#ED4337" }}>{mensagemErro}</p>
        </Modal>
      ) : null}
      {adicionarCategoriaIsOpen ? (
        <Modal
          container="containerAviso"
          onClose={() => setAdicionarCategoriaIsOpen(false)}
        >
          <p>Adicione uma nova categoria</p>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <label id="nova">Nova Categoria</label>
            <input
              id="nova"
              type="text"
              value={novaCategoria}
              onChange={(event) => setNovaCategoria(event.target.value)}
            />
            <input
              type="button"
              value="Adicionar"
              onClick={(e) => adicionarCategoria(e)}
              className="submitForm"
            />
          </form>
        </Modal>
      ) : null}
      {messageIsOpen ? (
        <Modal
          container="containerAviso"
          onClose={() => setMessageIsOpen(false)}
        >
          <p>Produto Adicionado com Sucesso!</p>
        </Modal>
      ) : null}
      {rejeitarIsOpen ? (
        <Modal
          container="containerAviso"
          onClose={() => setRejeitarIsOpen(false)}
        >
          <p>Deseja mesmo rejeitar essa sugestão?</p>
          <p style={{ fontWeight: 'bold', marginBottom: '15px' }}>{props.nome}</p>
          <label htmlFor="motivoRecusa" style={{ alignSelf: 'flex-start', marginBottom: '5px' }}>Motivo da recusa:</label>
          <textarea
            id="motivoRecusa"
            value={motivoRecusa}
            onChange={(e) => setMotivoRecusa(e.target.value)}
            placeholder="Ex: Código de barras ilegível, Produto já cadastrado, etc."
            style={{
              width: '100%',
              minHeight: '80px',
              padding: '10px',
              marginBottom: '15px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              resize: 'vertical',
              fontFamily: 'inherit'
            }}
          />
          <button
            type="button"
            onClick={(event) => rejeitar(event)}
            className="botaoSubmit"
            style={{
              width: "180px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {loading ? (
              <ReactLoading type="spin" color="#fff" height={20} width={20} />
            ) : (
              "Confirmar"
            )}
          </button>
        </Modal>
      ) : null}
      {editStatusIsOpen ? (
        <Modal
          container="containerAviso"
          onClose={() => setEditStatusIsOpen(false)}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            padding: '10px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '25px',
              borderBottom: '1px solid #eee',
              paddingBottom: '15px',
              width: '100%'
            }}>
              <span role="img" aria-label="tag" style={{ fontSize: '24px', marginRight: '10px' }}>🏷️</span>
              <h3 style={{
                margin: 0,
                color: '#2c3e50',
                fontSize: '20px',
                fontWeight: '700'
              }}>
                Gerenciar Status
              </h3>
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              width: '100%',
              maxWidth: '300px'
            }}>
              {/* Grupo de Status */}
              <div>
                <label style={{
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#7f8c8d',
                  marginBottom: '8px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block'
                }}>
                  Status Atual
                </label>
                <div style={{ position: 'relative' }}>
                  <div style={{
                    position: 'absolute',
                    left: '15px',
                    top: '37%',
                    transform: 'translateY(-50%)',
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: getStatusColor(statusEdit),
                    boxShadow: '0 0 5px rgba(0,0,0,0.1)',
                    zIndex: 1,
                    pointerEvents: 'none'
                  }} />
                  <select
                    style={{
                      width: '100%',
                      height: '48px',
                      padding: '0 35px 0 40px',
                      borderRadius: '8px',
                      border: '1px solid #dfe6e9',
                      backgroundColor: '#f8f9fa',
                      fontSize: '15px',
                      color: '#2d3436',
                      lineHeight: '48px', // Garantir centralização vertical do texto
                      outline: 'none',
                      cursor: 'pointer',
                      appearance: 'none',
                      // Seta customizada SVG
                      backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2395a5a6' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 12px center',
                      backgroundSize: '16px',
                    }}
                    value={statusEdit || ""}
                    onChange={(e) => setStatusEdit(e.target.value === "" ? null : e.target.value)}
                  >
                    <option value="">Sem Status</option>
                    <option value="pendente">Pendente</option>
                    <option value="em_cadastro">Em Cadastro</option>
                    <option value="aguardando_info">Aguardando Informação</option>
                    <option value="erro">Com Erro</option>
                    <option value="duplicada">Duplicada</option>
                  </select>
                </div>
              </div>

              {/* Grupo de Observação */}
              <div>
                <label style={{
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#7f8c8d',
                  marginBottom: '8px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block'
                }}>
                  Observações
                </label>
                <textarea
                  style={{
                    width: '100%',
                    minHeight: '100px',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid #dfe6e9',
                    backgroundColor: '#fff',
                    fontSize: '14px',
                    color: '#2d3436',
                    outline: 'none',
                    resize: 'vertical',
                    fontFamily: 'inherit',
                    lineHeight: '1.5',
                    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.03)'
                  }}
                  value={observacaoEdit}
                  onChange={(e) => setObservacaoEdit(e.target.value)}
                  placeholder="Escreva detalhes importantes sobre esta requisição..."
                  onFocus={(e) => e.target.style.borderColor = '#879F85'}
                  onBlur={(e) => e.target.style.borderColor = '#dfe6e9'}
                />
              </div>

              {/* Botão Salvar */}
              <button
                onClick={atualizarStatusRequisicao}
                style={{
                  width: '100%',
                  height: '50px',
                  marginTop: '10px',
                  backgroundColor: '#879F85',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: '0 4px 6px rgba(135, 159, 133, 0.3)',
                  transition: 'transform 0.1s, box-shadow 0.1s',
                }}
                onMouseDown={(e) => {
                  e.target.style.transform = 'translateY(1px)';
                  e.target.style.boxShadow = 'none';
                }}
                onMouseUp={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 6px rgba(135, 159, 133, 0.3)';
                }}
              >
                {loading ? (
                  <ReactLoading type="spin" color="#fff" height={24} width={24} />
                ) : (
                  <>
                    <span role="img" aria-label="save" style={{ marginRight: '8px' }}>💾</span> Salvar Alterações
                  </>
                )}
              </button>
            </div>
          </div>
        </Modal>
      ) : null}
    </ListElement>
  );
}
export default BoxRequisicao;
